module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    class: _vm.tabsClass
  }, [_vm._l((_vm.tabList), function(tab, index) {
    return _c('li', {
      class: tab.class
    }, [_c('a', {
      attrs: {
        "href": tab.id,
        "data-toggle": "tab"
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }), _vm._v(" "), _vm._t("nav")], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._t("content")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-797b40de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VACustomTab.vue
// module id = 532
// module chunks = 1